export default __webpack_public_path__ + "static/media/blockchainlogo.8a166424.png";